import React from 'react';
import PropTypes from 'prop-types';

export default function NegativeIcon(props) {
  const { fill, width, height } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 12.001 10.662'
    >
      <path
        id='União_94'
        data-name='União 94'
        d='M8482,20127.662h-5.521a.486.486,0,0,1-.42-.242.513.513,0,0,1,0-.484l5.521-9.689a.146.146,0,0,1,.015-.025.515.515,0,0,0,.03-.045.157.157,0,0,0,.03-.035c.011-.01.025-.02.036-.031a.284.284,0,0,0,.04-.029l.025-.016s.01,0,.015-.01l.046-.016a.115.115,0,0,1,.046-.02.171.171,0,0,1,.04-.01c.015,0,.03-.006.045-.006a.186.186,0,0,1,.046,0,.245.245,0,0,1,.051,0,.1.1,0,0,1,.04.006.156.156,0,0,1,.051.01l.04.016a.462.462,0,0,1,.046.02c0,.006.01.006.015.01a.062.062,0,0,1,.021.016l.046.029a.307.307,0,0,0,.03.031l.035.035c.01.016.021.031.03.045s.01.016.015.021l5.521,9.693a.487.487,0,0,1,0,.484.479.479,0,0,1-.419.242Zm-4.692-.969h9.38l-4.687-8.234Zm4.142-1.031a.548.548,0,1,1,.546.551A.547.547,0,0,1,8481.451,20125.662Zm0-1.373v-2.855a.549.549,0,0,1,1.1,0v2.855a.549.549,0,0,1-1.1,0Z'
        transform='translate(-8476.001 -20117)'
        fill={fill}
      />
    </svg>
  );
}

NegativeIcon.defaultProps = {
  fill: '#fff',
  width: 12.001,
  height: 10.662
};

NegativeIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};
